import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSquareFacebook,
  faTiktok,
  faInstagramSquare,
  faLinkedinIn,
  faSquareYoutube,
} from "@fortawesome/free-brands-svg-icons";

const socialLinks = [
  { icon: faSquareFacebook, label: "Facebook", href: "https://www.facebook.com/groups/1042928496984673/" },
  { icon: faTiktok, label: "TikTok", href: "https://www.tiktok.com/@freelancersplace.net" },
  { icon: faInstagramSquare, label: "Instagram", href: "https://www.instagram.com/freelancersplace/" },
  { icon: faLinkedinIn, label: "LinkedIn", href: "https://www.linkedin.com/company/freelancersplace-net/" },
  { icon: faSquareYoutube, label: "YouTube", href: "https://www.youtube.com/channel/UC0nsjp980Cb8qmcNqm2ayxw" },
];

const Footer = () => {
  return (
    <footer style={{ background: "#0d1117", color: "#9e9e9e", marginTop: "auto" }}>
      <div style={{ maxWidth: "1100px", margin: "0 auto", padding: "52px 24px 28px" }}>

        {/* Top row */}
        <div style={{
          display: "grid",
          gridTemplateColumns: "2fr 1fr 1fr",
          gap: "40px",
          marginBottom: "48px",
        }}>
          {/* Brand */}
          <div>
            <a href="/" style={{ display: "inline-block", marginBottom: "16px" }}>
              <img src="/dist/img/logo-1.jpg" alt="FreelancersPlace" style={{ height: "28px", width: "auto", borderRadius: "4px" }} />
            </a>
            <p style={{ fontSize: "0.88rem", lineHeight: 1.7, color: "#757575", maxWidth: "280px", margin: 0 }}>
              All the tools you need to manage your freelancing — from start to end.
            </p>
            {/* Social icons */}
            <div style={{ display: "flex", gap: "14px", marginTop: "20px" }}>
              {socialLinks.map(({ icon, label, href }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noreferrer"
                  title={label}
                  style={{ color: "#555", fontSize: "1.2rem", transition: "color 0.15s", textDecoration: "none" }}
                  onMouseEnter={(e) => { e.currentTarget.style.color = "#1a73e8"; }}
                  onMouseLeave={(e) => { e.currentTarget.style.color = "#555"; }}
                >
                  <FontAwesomeIcon icon={icon} />
                </a>
              ))}
            </div>
          </div>

          {/* Legal */}
          <div>
            <div style={{ fontSize: "0.72rem", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.1em", color: "#555", marginBottom: "16px" }}>
              Legal
            </div>
            <ul style={{ listStyle: "none", padding: 0, margin: 0, display: "flex", flexDirection: "column", gap: "10px" }}>
              {[
                { label: "Home", href: "/" },
                { label: "Privacy / Datenschutz", href: "/privacy" },
                { label: "Imprint / Impressum", href: "/imprint" },
              ].map(({ label, href }) => (
                <li key={label}>
                  <a href={href} style={{ fontSize: "0.88rem", color: "#757575", textDecoration: "none", transition: "color 0.15s" }}
                    onMouseEnter={(e) => { e.currentTarget.style.color = "#fff"; }}
                    onMouseLeave={(e) => { e.currentTarget.style.color = "#757575"; }}
                  >
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Help */}
          <div>
            <div style={{ fontSize: "0.72rem", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.1em", color: "#555", marginBottom: "16px" }}>
              Help & Support
            </div>
            <ul style={{ listStyle: "none", padding: 0, margin: 0, display: "flex", flexDirection: "column", gap: "10px" }}>
              <li>
                <a href="https://freelancersplace.net/blog" target="_blank" rel="noreferrer"
                  style={{ fontSize: "0.88rem", color: "#757575", textDecoration: "none", transition: "color 0.15s" }}
                  onMouseEnter={(e) => { e.currentTarget.style.color = "#fff"; }}
                  onMouseLeave={(e) => { e.currentTarget.style.color = "#757575"; }}
                >
                  Blog
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div style={{
          borderTop: "1px solid #1e2530",
          paddingTop: "20px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: "8px",
        }}>
          <span style={{ fontSize: "0.78rem", color: "#444" }}>
            © {new Date().getFullYear()} FreelancersPlace. All rights reserved.
          </span>
          <span style={{ fontSize: "0.78rem", color: "#444" }}>
            Built for freelancers, by freelancers.
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
